/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class GeojsonApi extends runtime.BaseAPI {
    /**
     * Geojson Hydrate
     */
    async geojsonHydrateRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling geojsonHydrate().');
        }
        if (requestParameters['geojsonHydrateRequestIn'] == null) {
            throw new runtime.RequiredError('geojsonHydrateRequestIn', 'Required parameter "geojsonHydrateRequestIn" was null or undefined when calling geojsonHydrate().');
        }
        const queryParameters = {};
        if (requestParameters['segmentLength'] != null) {
            queryParameters['segment_length'] = requestParameters['segmentLength'];
        }
        if (requestParameters['units'] != null) {
            queryParameters['units'] = requestParameters['units'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/geojson/{file_id}/hydrate`;
        urlPath = urlPath.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['geojsonHydrateRequestIn'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Geojson Hydrate
     */
    async geojsonHydrate(requestParameters, initOverrides) {
        const response = await this.geojsonHydrateRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
